export function initPastHighlights() {
  const toggleButton = document.querySelector('.highlights__toggle');
  const content = document.querySelector('.highlights__content');

  if (toggleButton && content) {
    toggleButton.addEventListener('click', () => {
      const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
      toggleButton.setAttribute('aria-expanded', !isExpanded);
      content.classList.toggle('is-expanded');
    });
  }
}